export default __webpack_public_path__ + "static/media/03__o_preview_2.ca32768f.jpg";